<!--
 * @Desc: 推荐阅读
 * @Author: 赵佳明
 * @Date: 2023-01-30 09:11:04
 * @LastEditors: wanglidong 王立冬
 * @LastEditTime: 2023-05-13 08:57:23
 * Copyright (c) 2023 山木枝(河北)技术服务有限公司, All Rights Reserved. 
-->
<template>
    <div class="read-component">
        <div class="pagination">
            <!-- Add Arrows -->
            <div class="pagination-prev">
                <img src="../../../public/statics/images/arr.png" />
            </div>
            <div class="pagination-next">
                <img src="../../../public/statics/images/arr.png" />
            </div>
        </div>
        <section class="swiper swiper-read">
            <div class="swiper-wrapper">
                <div class="swiper-slide" v-for="i in 4">
                    <div class="slide-thu">
                        <img
                            class="thu"
                            src="../../../public/statics/images/Index/icon-pic.jpg"
                        />
                    </div>
                    <div class="slide-desc ellipsis1">深入学习贯彻习近平总书记关于教育深入学习贯彻习近平总书记关于教育…</div>
                </div>
            </div>
        </section>
    </div>
</template>
<script>
export default {
    data() {
        return {
            swiper:'',
            imageUrl: require("../../../public/statics/images/Banner/banner1.jpg"),
        };
    },
    props: ["objectData"],
    computed: {},
    // watch:{
    //     $route(val){
    //         this.pageChange(val.name);
    //     }
    // },
    created: function () {},
    mounted: function () {
        let that = this
        this.swiper = new Swiper(".swiper-read", {
            // slidesPerView: "auto",
            slidesPerView: 4,
            spaceBetween: 20,
            loop: true,
            autoplay: {
                delay: 5000,
                stopOnLastSlide: false,
                disableOnInteraction: false,
            },
        });
        $('.read-component .pagination-prev').on('click',function(){
            // console.log($(this).index())
            that.swiper.slidePrev()
        })
        $('.read-component .pagination-next').on('click',function(){
            that.swiper.slideNext()
        })
    },
    methods: {},
};
</script>

<style scoped>
.read-component {
    margin-top: 30px;
    margin-bottom: 60px;
}
.read-component .pagination{
    display: flex;
    justify-content: flex-end;
}
.read-component .pagination-prev{
    width: 44px;
    height: 44px;
    background: rgba(0, 0, 0, 0.6);
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
}
.read-component .pagination-prev img{
    transform: rotateZ(180deg);
}
.read-component .pagination-next{
    width: 44px;
    height: 44px;
    background: rgba(0, 0, 0, 0.6);
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
}
.read-component .pagination-prev:hover,.read-component .pagination-next:hover{
    transition:all 0.3s ease-out;
    background: #1677FF;
}
.swiper {
    width: 100%;
    margin-top: 12px;
}

.swiper-slide {
    width: 285px;
    box-sizing: border-box;
}
.swiper-slide .slide-thu{
    width: 285px;
    height: 176px;
}
.swiper-slide .slide-thu .thu{
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
}
.swiper-slide .slide-desc{
    font-size: 16px;
    font-weight: 500;
    color: rgba(51, 51, 51, 1);
    position: relative;
    padding: 18px 0 20px 0;
}
.swiper-slide .slide-desc::after{
    content: '';
    position: absolute;
    left: 0;
    bottom: 0;
    width: 32px;
    height: 2px;
    background: #E22F24;
}
</style>
